// Outstanding-requirement codes → the sentence a Provider reads.
// Extracted from ClinicProfileEditor so the wording can be verified directly;
// the page remains the only consumer.

export const READINESS_ITEM_KEY_MAP = {
  'field:name':                     'field_name',
  'field:legal_name':               'field_legal_name',
  'field:contact_name':             'field_contact_name',
  'field:contact_surname':          'field_contact_surname',
  'field:tax_office':               'field_tax_office',
  'field:provider_type':            'field_provider_type',
  'field:address':                  'field_address',
  'field:contact_email':            'field_contact_email',
  'field:contact_phone':            'field_contact_phone',
  'field:tax_id':                   'field_tax_id',
  'field:personal_identity_number': 'field_personal_identity_number',
  'field:tax_id_format':            'field_tax_id_format',
  'field:personal_identity_number_format': 'field_personal_identity_number_format',
  'field:provider_profile':         'field_provider_profile',
  'banking:iban':                   'banking_iban',
  'banking:currency_ambiguous':     'banking_currency_ambiguous',
  'banking:bound_account_missing':  'banking_bound_account_missing',
  'banking:bound_account_inactive': 'banking_bound_account_inactive',
  'banking:bound_account_no_iban':  'banking_bound_account_no_iban',
  'banking:destination_unbound':    'banking_destination_unbound',
  'banking:account_store_unavailable': 'banking_account_store_unavailable',
  'banking:settlement_currency_ambiguous': 'banking_settlement_currency_ambiguous',
  'submerchant:ambiguous':            'submerchant_ambiguous',
  'submerchant:environment_mismatch': 'submerchant_environment_mismatch',
  'submerchant:restricted':           'submerchant_restricted',
  'submerchant:suspended':            'submerchant_suspended',
  'submerchant:closed':               'submerchant_closed',
  'representative:primary':         'representative_primary',
};

// One label resolver for every surface that lists outstanding items — a raw
// canonical code ('field:tax_office') must never reach the Provider.
export const readinessItemLabel = (item, t) => {
  const staticKey = READINESS_ITEM_KEY_MAP[item];
  if (staticKey) return t(`provider.profile.readiness.items.${staticKey}`);
  if (item?.startsWith?.('document:')) {
    const typeId = item.slice('document:'.length);
    return `${t('provider.profile.readiness.documentPrefix')}: ${typeId}`;
  }
  if (item?.startsWith?.('field:provider_type_unmapped:')) {
    const slug = item.split(':').pop();
    return `${t('provider.profile.readiness.unsupportedProviderType')}: ${slug}`;
  }
  // Banking blockers carry the settlement currency the bound registration is
  // paid in, so the provider is told WHICH account to add or re-link — never
  // a generic "information still required".
  if (item?.startsWith?.('banking:bound_account_currency:')) {
    return t('provider.profile.readiness.items.banking_bound_account_currency',
      { currency: item.split(':').pop() });
  }
  if (item?.startsWith?.('banking:iban_currency:')) {
    return t('provider.profile.readiness.items.banking_iban_currency',
      { currency: item.split(':').pop() });
  }
  if (item?.startsWith?.('banking:settlement_currency_unsupported:')) {
    return t('provider.profile.readiness.items.banking_settlement_currency_unsupported',
      { currency: item.split(':').pop() });
  }
  return t('provider.profile.readiness.items.generic');
};

